import bootstrap from "../common/bootstrap.js";
import Page from "../pages/cart-detail.js";
bootstrap(Page);
